export const DebugLog = (log) => {
    if (process.env.REACT_APP_ENV !== "production")
        console.log(log);
};
